import {
  ApplicationConfig,
  importProvidersFrom,
  provideExperimentalZonelessChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { errorHandlerInterceptor } from './core/interceptor/error-handler.interceptor';
import { headerInterceptor } from './core/interceptor/header.interceptor';
import { MyPreset } from './preset.primeng';

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideExperimentalZonelessChangeDetection(),
    provideRouter(routes),
    provideAngularSvgIcon(),
    provideHttpClient(),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: '.no-dark-mode',
        },
      },
    }),
    importProvidersFrom([]),
    provideHttpClient(withInterceptors([errorHandlerInterceptor, headerInterceptor])),
    provideAnimationsAsync(),
    ConfirmationService,
    DialogService,
  ],
};
